// src/ContactFormWithMap.js
import React from 'react';
import { Box, TextField, Button, Typography, Checkbox, FormControlLabel, Grid, useTheme } from '@mui/material';
import { CommonHeading, CommonTitle, DesignBtn } from '../../../../layout/Common';

const ContactFormWithMap = () => {
    const theme = useTheme();

    return (
        <Box>
            <Grid container>
                <Grid xs={12}>
                    <Box sx={{ height: {lg:'100%',xs:'100vh'} }}>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3710.524913648238!2d72.79970281475887!3d21.17024098592445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e8b77b3b0b1%3A0xa4b014e29c8b5d4!2sSurat%2C%20Gujarat%2C%20India!5e0!3m2!1sen!2sus!4v1659492208562!5m2!1sen!2sus"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </Box>

                </Grid>
                <Grid xs={12} lg={6}>
                    {/* <Box sx={{ backgroundColor: theme.palette.background.brownDark, p: {md:'80px 100px',xs:'50px 40px' }}}>
                        <CommonTitle text={'Please Elaborate On Your Needs'} margin={'0px 0px 15px 0px'} />
                        <CommonHeading text={"Please Use This Form For Any General Queries & Concerns."} fontSize={"39px"} fontWeight={"400"} />
                        <Box sx={{ mt: 3 }}>
                            <TextField
                                label="Your Name*"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                InputLabelProps={{ style: { color: '#9a9998' } }}
                                InputProps={{ style: { color: '#9a9998', borderColor: '#9a9998', my: 3 } }}
                            />
                        </Box>

                        <Box sx={{ mt: 3 }}>
                            <TextField
                                label="Your Email Id*"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                InputLabelProps={{ style: { color: '#9a9998' } }}
                                InputProps={{ style: { color: '#9a9998', borderColor: '#9a9998' } }}
                            />
                        </Box>

                        <Box sx={{ my: 3 }}>
                            <TextField
                                label="Tell us about you*"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                multiline
                                rows={4}
                                InputLabelProps={{ style: { color: '#9a9998' } }}
                                InputProps={{ style: { color: '#9a9998', borderColor: '#9a9998' } }}
                            />
                        </Box>
                        <Box mt={2}>
                            <CommonTitle text={'How We Can Help'} margin={'0px 0px 20px 0px'} />


                            <Box>
                                <FormControlLabel
                                    control={<Checkbox style={{ color: '#9a9998' }} />}
                                    label="Fashion"
                                    style={{ color: '#9a9998', fontFamily: theme.palette.typography.fontFamily1, marginRight: {md:'40px',xs:'-4px'} }}
                                />
                                <FormControlLabel
                                    control={<Checkbox style={{ color: '#9a9998' }} />}
                                    label="Jewelry"
                                    style={{ color: '#9a9998', fontFamily: theme.palette.typography.fontFamily1, marginRight: {md:'40px',xs:'-4px'} }}
                                />
                                <FormControlLabel
                                    control={<Checkbox style={{ color: '#9a9998' }} />}
                                    label="Watches"
                                    style={{ color: '#9a9998', fontFamily: theme.palette.typography.fontFamily1, marginRight: {md:'40px',xs:'-4px'} }}
                                />
                            </Box>
                            <Box sx={{ mb: 5 }}>
                                <FormControlLabel
                                    control={<Checkbox style={{ color: '#9a9998' }} />}
                                    label="Fitness"
                                    style={{ color: '#9a9998', fontFamily: theme.palette.typography.fontFamily1, marginRight: {md:'40px',xs:'-4px'} }}
                                />
                                <FormControlLabel
                                    control={<Checkbox style={{ color: '#9a9998' }} />}
                                    label="Other"
                                    style={{ color: '#9a9998', fontFamily: theme.palette.typography.fontFamily1, marginRight: {md:'40px',xs:'-4px'} }}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ width:{xl:'30%',lg:'50%',md:'30%',sm:'40%'}}}>

                    <DesignBtn text={"LET'S GET START"} width={'100%'} />
                    </Box>

                </Box> */}
            </Grid>

        </Grid>
        </Box >
    );
};

export default ContactFormWithMap;
